import React from "react";
import { CircleCheck, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Datenverwendung() {
  const liabilityItems = ["Zur Bereitstellung und Optimierung unserer digitalen Dienstleistungen", "Zur Gewährleistung der IT-Sicherheit und des Schutzes unserer Systeme", "Zur Analyse des Nutzerverhaltens für eine verbesserte User Experience", "Zur Erfüllung gesetzlicher Aufbewahrungspflichten und Compliance-Vorgaben"];
  return <section data-section-id="258890" id="datenverwendung" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-[800px] flex flex-col gap-12">
        
        {}
        <div className="flex flex-col gap-4">
          <h2 className="font-default text-[24px] font-bold text-primary">
            1. Erhebung und Speicherung von Daten
          </h2>
          <p className="font-default text-[16px] text-muted-foreground leading-[1.6]">
            Die Nutzung der Website <strong className="font-semibold text-foreground">CHROTECH&nbsp;</strong> erfolgt unter strikter Einhaltung der DSGVO:
          </p>
          
        </div>

        {}
        <div className="flex flex-col gap-4">
          <h2 className="font-default text-[24px] font-bold text-primary">
            2. Verantwortliche Instanz
          </h2>
          <p className="font-default text-[16px] text-muted-foreground leading-[1.6]">
            Verantwortlich für die Datenverarbeitung ist die <strong className="font-semibold text-foreground">CHROTECH Geschäftsführung</strong>, vertreten durch die Abteilung für Informationssicherheit.
          </p>
        </div>

        {}
        

        {}
        <div className="flex flex-col gap-4">
          <h2 className="font-default text-[24px] font-bold text-primary">3. Zweck der Datenverarbeitung</h2>
          <div className="flex flex-col gap-4 font-default text-[16px] text-muted-foreground leading-[1.6]">
            <p>
              Sämtliche auf dieser Plattform erhobenen Daten (Logs, Metadaten, Nutzerinteraktionen) dienen ausschließlich der technischen Bereitstellung und der kontinuierlichen Verbesserung unserer technologischen Lösungen.
            </p>
            <p>
              Wir setzen modernste Verschlüsselungsverfahren ein, um die Integrität und Vertraulichkeit Ihrer Informationen während der Übertragung und Speicherung zu gewährleisten.
            </p>
            <p>
              Eine Weitergabe an Dritte erfolgt nur, sofern dies zur Vertragserfüllung zwingend erforderlich ist oder eine gesetzliche Verpflichtung besteht.
            </p>
          </div>
        </div>

        {}
        

        {}
        

        {}
        <div className="flex flex-col gap-4">
          <h2 className="font-default text-[24px] font-bold text-primary">4. Rechte der betroffenen Personen</h2>
          <div className="flex flex-col gap-4 font-default text-[16px] text-muted-foreground leading-[1.6]">
            <p>
              Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung oder Einschränkung der Verarbeitung Ihrer gespeicherten Daten gemäß den geltenden Datenschutzgesetzen.
            </p>
            <p>
              Für die Ausübung Ihrer Rechte wenden Sie sich bitte schriftlich an unsere Datenschutzabteilung. Im Falle von Unstimmigkeiten steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
            </p>
          </div>
        </div>

        {}
        <div className="flex flex-col gap-4">
          <h2 className="font-default text-[24px] font-bold text-primary">5. Kontakt für Datenschutzfragen</h2>
          <p className="font-default text-[16px] text-muted-foreground leading-[1.6]">
            Bei technischen oder rechtlichen Fragen zur Datenverwendung erreichen Sie uns hier:
          </p>
          <div className="bg-card border border-border rounded-lg p-6 flex flex-col gap-4 font-default text-[16px] text-muted-foreground shadow-md">
            <div className="flex items-center gap-3">
              <Phone className="w-5 h-5 text-primary shrink-0" />
              <Link to="tel:08001234567" className="hover:text-foreground transition-colors">+49 157 31141389</Link>
            </div>
            <div className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-primary shrink-0" />
              <Link to="mailto:privacy@chrotech-solutions.de" className="hover:text-foreground transition-colors">info@chrotechs.com</Link>
            </div>
            <div className="flex items-center gap-3">
              <MapPin className="w-5 h-5 text-primary shrink-0" />
              <span>An den Kreutzmorgen 9<br />507373 Köln</span>
            </div>
          </div>
        </div>

        {}
        <div className="pt-8 text-center border-t border-border">
          <p className="font-default text-sm text-muted-foreground">
            Stand der Dokumentation: 24. Mai 2024
          </p>
        </div>

      </div>
    </section>;
}